import React, { Component } from 'react';
import { connect } from "react-redux";
import SettingsHeader from "../../SettingsHeader";

import FormAccordion from "./FormAccordion";
import {savePreChatForm} from "../../../../actions/actions";
import Loading from "../../../Loading"
import API from "../../../../lib/api";
import {toast} from "react-toastify";

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class PreChatForm extends Component {

    constructor(props) {
        super(props);
        this.addItemsClick=this.addItemsClick.bind(this);
        this.setValue=this.setValue.bind(this);
        this.changeRequired=this.changeRequired.bind(this);
        this.saveForm=this.saveForm.bind(this);
        this.disabledButtonCheck=this.disabledButtonCheck.bind(this);
        this.removeForm=this.removeForm.bind(this);
        var form_items=[
            {
                "name" : "Information",
                "id" :"information",
                "icon" : "bx bxs-grid",
                "type" : "textarea",
                "label" : "Message",
                "default":"Please fill in the form below before starting the chat.",
                "disabled":false,
                "required":false,
                "error":false,
                "is_required":false
            },
            {
                "name" : "Name",
                "id" :"name",
                "icon" : "bx bx-text",
                "type" : "text",
                "label" : "Label",
                "default":"Name:",
                "disabled":false,
                "required":true,
                "error":false,
                "is_required":false
            },
            {
                "id":"email",
                "name" : "Email",
                "icon" : "bx bx-text",
                "type" : "text",
                "label" : "Label",
                "default":"E-mail:",
                "disabled":false,
                "required":true,
                "error":false,
                "is_required":false
            },
            {
                "id":"question",
                "name" : "Question",
                "icon" : "bx bx-text",
                "type" : "text",
                "label" : "Question",
                "default":"Question:",
                "disabled":false,
                "required":true,
                "error":false,
                "is_required":false
            }
        ];
        this.state = {
            formItems: form_items,
            selectedForm:[],
            saveButtonDisabled:true,
            loading:false
        };
    }
    saveForm(){
        var selectedForm=this.state.selectedForm;


            var __self=this;
            $.each(selectedForm, function (k, v) {
                var defaultName=v['default'].trim();
                if(defaultName.length<1){

                    selectedForm[k]['error']=true;
                    __self.setState({
                        selectedForm:selectedForm
                    });
                    return false;
                }
            });
            setTimeout(function () {

                __self.props.dispatch(savePreChatForm({
                    formjson:JSON.stringify(selectedForm)
                }));

            }, 500);





    }
    removeForm(index,id){
        var selectedForm=this.state.selectedForm;
        if(typeof selectedForm[index]!=="undefined") {
            var itemFind = this.state.formItems.find(item => item.id == id);
            if (typeof itemFind !== "undefined") {
                var itemIndex = this.state.formItems.findIndex(item => item.id == id);


                if (id == "name" || id == "email") {
                    var formItems = this.state.formItems;
                    formItems[itemIndex]['disabled'] = false;
                    this.setState({
                        formItems: formItems
                    });
                }
                this.disabledButtonCheck();
                selectedForm.splice(index, 1);
                this.setState({
                    selectedForm: selectedForm
                });
            }
        }
    }
    changeRequired(id){
        var selectedForm=this.state.selectedForm;
        if(typeof selectedForm[id]!=="undefined"){
            if(selectedForm[id]['required']===true){
                selectedForm[id]['is_required']=  !selectedForm[id]['is_required'];

                this.setState({
                    selectedForm:selectedForm
                });
                this.disabledButtonCheck();
            }
        }
    }
    setValue(e,id){
        var selectedForm=this.state.selectedForm;
        if(typeof selectedForm[id]!=="undefined"){

            selectedForm[id]['default']=e.target.value;
            selectedForm[id]['error']=false;
            this.setState({
                selectedForm:selectedForm
            });
            this.disabledButtonCheck();

        }

    }
    addItemsClick(id){
        var itemFind=this.state.formItems.find(item=>item.id==id);


        if(typeof itemFind!=="undefined"){
            var itemIndex=this.state.formItems.findIndex(item=>item.id==id);
            var newItem={};
            var selectedForm=this.state.selectedForm;

            if(id=="name" || id=="email"){
                var itemName=this.state.selectedForm.find(item=>item.id==id);
                if(typeof itemName!=="undefined"){
                    return false;
                }
            }


            newItem.id=itemFind.id;
            newItem.name=itemFind.name;
            newItem.icon=itemFind.icon;
            newItem.type=itemFind.type;
            newItem.label=itemFind.label;
            newItem.default=itemFind.default;
            newItem.error=itemFind.error;
            newItem.required=itemFind.required;
            newItem.is_required=itemFind.is_required;
            selectedForm.push(newItem);

            this.setState({
                selectedForm:selectedForm
            });

            if(id=="name" || id=="email"){
                var formItems=this.state.formItems;
                formItems[itemIndex]['disabled']=true;
                this.setState({
                    formItems:formItems
                });
                this.disabledButtonCheck();
            }

        }
    }

    disabledButtonCheck(){
        var selectedForm = this.state.selectedForm;

        var disabledx = false;
        if (selectedForm.length > 0) {
            var __self = this;
            $.each(selectedForm, function (k, v) {
                var defaultName = v['default'].trim();
                if (defaultName.length < 1) {
                    __self.setState({
                        saveButtonDisabled: true
                    });
                    disabledx = true;
                    return false;
                }
            });
            if(disabledx===false){
                this.setState({
                    saveButtonDisabled: false
                });
            }
        } else{

                this.setState({
                    saveButtonDisabled: true
                });

        }

    }
    componentWillUnmount() {

    }

    componentDidUpdate(prevProps, prevState, snapshot) {




    }

    componentDidMount() {
        var formData = new FormData();

        API.post("settings/get",formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.error!=="undefined"){
                    response.data.message.error.forEach(msg=>{
                        toast.error(msg);
                    });
                } else{
                    if(typeof response.data.message.data.prechatform!=="undefined"){
                        this.setState({
                            selectedForm: response.data.message.data['prechatform']
                        });

                    }
                    this.setState({
                        loading: true
                    });
                    this.disabledButtonCheck();
                }
            }
        });


    }

    render() {

        const { formItems } = this.state;
        const { selectedForm } = this.state;
        if(this.state.loading===false){
            return (<React.Fragment><Loading></Loading></React.Fragment>)
        } else {
            return (
                <React.Fragment>
                    <SettingsHeader title="Pre Chat Form"/>
                    <div className="settings-center-wrap">
                        <div className="prechat-form-container settings-code-block settings-code-block-clean ">
                            <h6 className=" title canned-responses-h6 hv-form-add-button">
                                <button className="btn btn-primary btn-sm" data-toggle="dropdown">
                                    <i className='bx bx-plus'></i>&nbsp;Add element
                                </button>
                                <div className="dropdown-menu dropdown-menu-right">
                                    {formItems.map(item => {
                                        return (
                                            <div className="hv-setting-dropdown-item-div">
                                                <button
                                                    className={"dropdown-button " + (item.disabled === true ? "disabled" : "")}
                                                    onClick={() => this.addItemsClick(item.id)}>
                                                    <span className="icon">
                                                        <i className={item.icon}></i>
                                                    </span>
                                                    {item.name}
                                                </button>
                                            </div>
                                        )
                                    })}

                                </div>
                            </h6>
                            {this.state.selectedForm.map((item, index) => {
                                return (
                                    <FormAccordion id={item.id} removeForm={this.removeForm} error={item.error}
                                                   is_required={item.is_required} required={item.required}
                                                   title={item.name} index={index} setValue={this.setValue}
                                                   changeRequired={this.changeRequired} clicked={true}
                                                   icon="bx bx-customize" labelname={item.label} defaultv={item.default}
                                                   type={item.type}/>
                                )
                            })}

                        </div>

                        <div className="swal2-container swal2-center swal2-backdrop-show">
                            <div style={{display: "grid"}} aria-modal="true" aria-live="assertive" role="dialog"
                                 aria-describedby="swal2-html-container" aria-labelledby="swal2-title"
                                 className="swal2-popup swal2-modal swal2-show">
                                <div className="swal2-actions">
                                    <button onClick={() => this.saveForm()} type="button"
                                            className={"swal2-confirm swal2-styled " + (this.state.saveButtonDisabled === true ? "disabled" : "")}
                                            style={{display: "inline-block"}}>
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    }
}

export default PreChatForm;
